import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BACKEND_API_URL } from '../../../utility/api';

export const apiWithoutAuth = createApi({
  reducerPath: 'apiWithoutAuth',
  baseQuery: fetchBaseQuery({ baseUrl: BACKEND_API_URL }),
  endpoints: (builder) => ({
    registerUser: builder.mutation({
        query: (data) => ({
          url: 'users/register',
          method: 'POST',
          body: data,
        }),
      }),

      verifyOtp: builder.mutation({
        query: (data) => ({
          url: 'users/verify-otp',
          method: 'POST',
          body: data,
        }),
      }),

      loginUser: builder.mutation({
        query: (data) => ({
          url: 'users/login',
          method: 'POST',
          body: data,
        }),
      }),

      adminLogin: builder.mutation({
        query: (data) => ({
          url: 'admin/login',
          method: 'POST',
          body: data,
        }),
      }),

      doctorLogin: builder.mutation({
        query: (data) => ({
          url: 'doctor-auth/login',
          method: 'POST',
          body: data,
        }),
      }),

      receptionistLogin: builder.mutation({
        query: (data) => ({
          url: 'receptionist-auth/login',
          method: 'POST',
          body: data,
        }),
      }),

      forgotPassword: builder.mutation({
        query: (data) => ({
          url: 'users/forgot-password',
          method: 'POST',
          body: data,
        }),
      }),

      resetPassword: builder.mutation({
        query: (data) => ({
          url: 'users/reset-password',
          method: 'POST',
          body: data,
        }),
      }),

      setActivationPassword: builder.mutation({
        query: ({ role, token, password }) => {
          const endpointByRole = {
            doctor: 'doctor-auth/set-password',
            receptionist: 'receptionist-auth/set-password',
            patient: 'patient-portal/set-password',
          };

          return {
            url: endpointByRole[role] || 'doctor-auth/set-password',
            method: 'POST',
            body: { token, password },
          };
        },
      }),



    getPublicData: builder.query({
      query: () => '/public/data',
    }),
  }),
});


export const { useGetPublicDataQuery,
    useLoginUserMutation,
    useAdminLoginMutation,
    useDoctorLoginMutation,
    useReceptionistLoginMutation,
    useVerifyOtpMutation,
    useRegisterUserMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useSetActivationPasswordMutation,


 } = apiWithoutAuth;
